import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';
import x from 'open-iconic/svg/x.svg';
import { Badge } from 'reactstrap';

import { noop } from 'lib/noop';
import { IconButton } from 'ui/Components';

import styles from './Chip.css';

/**
 * render a chip component for displaying search tags
 * @param {object} props - props passed to this component
 * @returns {React.Component} a chip component
 */
const Chip = props => (
  <span className={`d-inline-flex ${props.className}`}>
    {props.leftText && (
      <Badge
        className={`d-inline-flex align-items-center rounded-left ${styles.text}`}
        color={props.leftColor}
      >
        <span className="d-inline-block text-truncate" title={props.leftText}>
          {props.leftText}
        </span>
      </Badge>
    )}
    {props.rightText && (
      <Badge
        className={classnames('d-inline-flex', 'align-items-center', styles.text, {
          'rounded-left': !props.leftText,
          'rounded-right': props.hideClose
        })}
        color={props.rightColor}
      >
        <span className="d-inline-block text-truncate" title={props.rightText}>
          {props.rightText}
        </span>
      </Badge>
    )}
    {!props.hideClose && (
      <Badge
        className={classnames('d-inline-flex', 'align-items-center', 'rounded-right', {
          'pl-0': !!props.rightText
        })}
        color={props.rightColor}
      >
        <IconButton
          alt="x icon"
          icon={x}
          rem={0.8}
          noMargin
          onClick={props.onClose}
          isReadonly={props.isReadonly}
        />
      </Badge>
    )}
  </span>
);

Chip.propTypes = {
  className: propTypes.string,
  leftColor: propTypes.string,
  rightColor: propTypes.string,
  leftText: propTypes.string,
  rightText: propTypes.oneOfType([propTypes.string, propTypes.array]),
  onClose: propTypes.func,
  hideClose: propTypes.bool,
  isReadonly: propTypes.bool
};

Chip.defaultProps = {
  className: '',
  leftColor: 'primary',
  rightColor: 'light',
  leftText: '',
  rightText: '',
  onClose: noop,
  hideClose: false,
  isReadonly: false
};

export default Chip;
